import { render, staticRenderFns } from "./MaterialForm.vue?vue&type=template&id=f12053f4"
import script from "./MaterialForm.vue?vue&type=script&lang=js"
export * from "./MaterialForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports